var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 2.682h-2v-.667A1.333 1.333 0 0 0 8.333.682H5.667a1.333 1.333 0 0 0-1.334 1.333v.667h-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm-6-.667h2.666v.667H5.667v-.667zm6.666 8.667a.667.667 0 0 1-.666.666H2.333a.666.666 0 0 1-.666-.666v-3.74l3.12 1.073c.07.01.142.01.213 0h4a.793.793 0 0 0 .213-.033l3.12-1.04v3.74zm0-5.147l-3.44 1.147H5.107l-3.44-1.147v-.853a.667.667 0 0 1 .666-.667h9.334a.667.667 0 0 1 .666.667v.853z",
    fill: "#696871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashimg2);
export default __webpack_public_path__ + "static/media/dashimg2.ac131b82.svg";
export { ForwardRef as ReactComponent };